<template>
  <!-- This component doesn't need hydration, so we don't pass any params -->
  <LazyHydrate>
    <ResponsiveWrapper
      v-bind="$attrs"
      :component="blok.component"
      :devices="blok.devices"
    >
      <SectionWrapper :blok="blok" padding="none">
        <div
          class="relative overflow-hidden"
          :class="backgroundColorClass(blok.bgVariant)"
        >
          <WidthWrapper width="block">
            <ul
              class="place-items-left grid gap-8 md:grid-cols-2 lg:gap-14"
              :class="gridClass"
            >
              <li v-for="icon in blok.IconListItem" :key="icon._uid">
                <IconListItem
                  :icon="icon"
                  :blok="blok"
                  :icon-color="blok.iconColor"
                />
              </li>
            </ul>
          </WidthWrapper>
        </div>
      </SectionWrapper>
    </ResponsiveWrapper>
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import ResponsiveWrapper from '../components/ResponsiveWrapper.vue'
import WidthWrapper from '../components/WidthWrapper.vue'
import SectionWrapper from '../components/SectionWrapper.vue'
import IconListItem from '../components/IconListItem.vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const gridClass = computed(() => {
  const gridColsMap = {
    3: 'lg:grid-cols-3',
    4: 'lg:grid-cols-4',
    5: 'lg:grid-cols-5',
    6: 'lg:grid-cols-6',
  }
  const maxCols = 6
  const minCols = 3
  const nCols = Math.max(minCols, Math.min(props.blok.columns, maxCols))

  return gridColsMap[nCols]
})

const { backgroundColorClass } = useColorPalette()
</script>
